/*
  A Lorinthe project.

  @Author: Tom Voorneveld <tom>
  @Date:   2019-03-19T21:17:03+02:00
  @Email:  tom@lorinthe.com
  @Project: Lorinthe
  @Last modified by:   tom
  @Last modified time: 2019-06-12T16:31:29+02:00
  @Copyright: (c) copyright Lorinthe BV, all rights reserved

  Use:
    import Conf from '@/config/settings'
*/

// ** Debug parameter
//
const OVERRIDE_DEV_MODE = 'dev' // 'prod' || 'test' || 'dev' = no override

let RUN_ENV
if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
  RUN_ENV = OVERRIDE_DEV_MODE
} else if (window.location.href.includes('nuricon.net')) {
  RUN_ENV = 'test'
} else {
  RUN_ENV = 'prod'
}

const BLOG_API_URL = {
  // dev: 'http://localhost:3170/',
  dev: 'https://qapi.nuricon.net/',
  test: 'https://qapi.nuricon.net/',
  prod: 'https://qapi.qrespi.net/'
}

const TEST_CHANNEL = -1001327624885 // QrespiTestBlog
const BLOG_ID = {
  en: {
    dev: TEST_CHANNEL,
    test: TEST_CHANNEL,
    prod: -1001233110279
  },
  nl: {
    dev: TEST_CHANNEL,
    test: TEST_CHANNEL,
    prod: -1001196767669
  }
}

// currencies handled by us
const CURRENCY_REGIONS = {
  us: 'usd',
  uk: 'gbp',
  gb: 'gbp',
  ca: 'cad',
  au: 'aud'
}

const CURRENCY_RATES = {
  aud: { rate: 1.57, symbol: 'AU$', string: 'Australian Dollar' },
  cad: { rate: 1.50, symbol: 'C$', string: 'Canadian Dollar' },
  eur: { rate: 1.00, symbol: '€', string: 'Euro' },
  gbp: { rate: 0.90, symbol: '£', string: 'British Pound' },
  usd: { rate: 1.15, symbol: '$', string: 'US Dollar' }
}
//
// ** Do not change below this line

//
// ** Exported parameters
//
const CONFIG = {
  RUN_ENV: RUN_ENV,

  // To use package.json.version, please add to your /vue.config.js:
  //  pluginOptions: { VERSION: JSON.stringify(require('./package.json').version) }
  /* global VERSION */
  version: VERSION,
  serial_version: serialVersion(VERSION), // e.g. 1403;  Qrespi standard for version compare
  installed_languages: ['en', 'nl'],

  currency: {
    language: (navigator.userLanguage || navigator.language).substr(3, 2).toLowerCase(),
    regions: CURRENCY_REGIONS,
    rates: CURRENCY_RATES
  },

  blog_store: {
    team: 'Qrespi Marketing',
    id: (lang) => BLOG_ID[lang][RUN_ENV],
    url: BLOG_API_URL[RUN_ENV] + 'qblog',
    public_url: BLOG_API_URL[RUN_ENV] + 'static',
    blog_par: '/getBlogPosts',
    tags_par: '/getBlogTags'
  },

  google: {
    analytics: {
      id: 'UA-128214802-2' // www.lorinthe.com is UA-3065002-1
    }
  }
}

export default CONFIG

//
// ** Helpers

// Calculate a serial version to compare versions if needed when migrating
//
function serialVersion (version) {
  // for example, 4.1.56 = 40156
  const v = version.split('.')
  return (parseInt(v[0]) * 10000) + (parseInt(v[1]) * 100) + parseInt(v[2])
}
